import { omit } from 'lodash';
import { FETCH_RELATED_POSTS_SUCCESS } from '../actions/fetch-related-posts';
import {
  INCREMENT_POST_LIKE_COUNT_FAILURE,
  INCREMENT_POST_LIKE_COUNT_REQUEST,
  INCREMENT_POST_LIKE_COUNT_SUCCESS,
} from '../../common/actions/increment-post-like-count';
import { DELETE_CATEGORY_SUCCESS } from '../actions/delete-category';

export function relatedPosts(state = [], { type, payload } = {}) {
  switch (type) {
    case FETCH_RELATED_POSTS_SUCCESS:
      return payload;
    case INCREMENT_POST_LIKE_COUNT_REQUEST:
      return state.map(post => {
        if (post._id !== payload._id) {
          return post;
        }
        return {
          ...post,
          isLiked: !post.isLiked,
          likeCount: post.likeCount + (post.isLiked ? -1 : 1),
          isLikeInProgress: true,
        };
      });
    case INCREMENT_POST_LIKE_COUNT_SUCCESS:
      return state.map(post => {
        if (post._id !== payload._id) {
          return post;
        }
        return omit({ ...post, ...payload }, 'isLikeInProgress');
      });
    case INCREMENT_POST_LIKE_COUNT_FAILURE:
      return state.map(post => {
        if (post._id !== payload._id) {
          return post;
        }
        return omit(
          {
            ...post,
            isLiked: !post.isLiked,
            likeCount: post.likeCount + (post.isLiked ? -1 : 1),
          },
          'isLikeInProgress',
        );
      });
    case DELETE_CATEGORY_SUCCESS:
      return state.filter(p => p.categoryId !== payload);
    default:
      return state;
  }
}
